export default __webpack_public_path__ + "static/media/plaid_white_logo.94e89fab.svg";